import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetUrlMetadataQueryVariables = Types.Exact<{
	fullPath: Types.Scalars['String']['input'];
	site?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetUrlMetadataQuery = {
	__typename?: 'Query';
	urlV2: {
		__typename?: 'Url';
		id: string;
		urlID: number;
		locale: string;
		objectType: Types.ObjectType;
		fullPath: string;
		heading1?: string | null;
		heading2?: string | null;
		metaTitle?: string | null;
		metaDescription?: string | null;
		metaRobots?: string | null;
		metaKeywords?: string | null;
		htmlContent?: string | null;
		htmlContentJson?: any | null;
		site: string;
		hrefLangTags: Array<{
			__typename?: 'HrefLangTag';
			href: string;
			hrefLang: string;
			locale: string;
			hasNoindex: boolean;
		}>;
		page?: { __typename?: 'Page'; id: string; technicalName: string } | null;
	};
};

export const GetUrlMetadataDocument = gql`
	query GetUrlMetadata($fullPath: String!, $site: String) {
		urlV2(fullPath: $fullPath, site: $site) {
			id
			urlID
			locale
			objectType
			fullPath
			heading1
			heading2
			metaTitle
			metaDescription
			metaRobots
			metaKeywords
			hrefLangTags {
				href
				hrefLang
				locale
				hasNoindex
			}
			page {
				id
				technicalName
			}
			htmlContent
			htmlContentJson
			site
		}
	}
`;
